import { path as parentPath } from "../init";

export const apiUrls = {
  list: "/api/specials/casts",
  compilation: "/api/specials/casts/compilation",
  compilations_test: "/api/specials/casts/compilations_test",
  message_settings: "/api/specials/casts/settings",
  info: "/api/specials/casts/special_{specialId}",
  publish: "/api/specials/casts/special_{specialId}/startPublish",
  reset: "/api/specials/casts/special_{specialId}/reset",
  delete: "/api/specials/casts/special_{specialId}/delete",
  settings: "/api/specials/casts/special_{specialId}/settings",
  getTrailer: "/api/specials/casts/special_{specialId}/getTrailer",
  createCover: "/api/specials/casts/special_{specialId}/createCover",
  messages: "/api/specials/casts/special_{specialId}/messages",
  messagesPack: "/api/specials/casts/special_{specialId}/messages/pack",
  messagesPositions: "/api/specials/casts/special_{specialId}/messages/positions",
  messageInfo: "/api/specials/casts/special_{specialId}/messages/message_{messageId}",
};

export const path = `${parentPath}/casts`;

export const infoLink = (special) => {
  return `${path}/special_${special._id}`;
};

export const formLink = (special) => {
  return `${infoLink(special)}/form`;
};
